import React   from 'react';
import values  from '../../../../../../values';
import Context from '../../../../../../context';

import { useTranslation } from 'react-i18next';
import {
  CustomButton2,
  ResponsiveView,
  CustomDropdownFilter,
  CustomRadioButtonGroup,
} from '../../../../../../components';

import './index.scss';
import {IItem} from "../../../../../../types/common.interface";

const Filter: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [selectedItem, setSelectedItem] = React.useState<IItem | null>(null);
  const { request, setRequest } = React.useContext(Context.FactorsNeedPay2CompanyScreenContext);
  const { t } = useTranslation();

  const items: Array<IItem> = [
    {_id: 0, name: 'راننده' , value: 'DRIVER'   },
    {_id: 1, name: 'اولیاء' , value: 'PASSENGER'},
  ];

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function handleOnClickRestFactors(): void {
    setSelectedItem(null);
    setRequest({
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      endAt: new Date(),
      page: 1,
    });
  }

  function handleonClickRadioButton(event: IItem | null): void {
    if (event === null) return;
    setSelectedItem(event);
    setRequest({
      ...request,
      page: 1,
      payerType: event?.value,
    })
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section className="filter-container">
      <CustomDropdownFilter title={t("filter")} hoverTitle={t("filter")} min_width="30vw">
        <ResponsiveView.Row style={{padding: '1rem 2rem 0 0'}}>
          <ResponsiveView.Column small={12}>
            <CustomRadioButtonGroup menus={items} onClick={handleonClickRadioButton} selected={selectedItem} />
          </ResponsiveView.Column>
        </ResponsiveView.Row>
        <ResponsiveView.Column className="filter-footer">
          <CustomButton2 title={t("reset")} onClick={handleOnClickRestFactors} type="primary"/>
        </ResponsiveView.Column>
      </CustomDropdownFilter>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Filter;
